module.exports = __webpack_public_path__ + "img/back_admin_dashboard.37177d10.svg";